import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabservice() {



    const cardData = {

keyword: "Pune to Goa Cab Service",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and affordable Pune to Goa Cab Service for families, couples, groups, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth long-distance journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you're planning a beach holiday, family vacation, or group trip, Rising Cab Service ensures a relaxing and hassle-free travel experience from Pune to Goa.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa's most famous tourist destinations, known for its golden sands, water sports, beach shacks, nightlife, and lively atmosphere. It is a favorite spot for families and adventure lovers."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach, often called the Queen of Beaches, is popular for its wide shoreline, shopping markets, water activities, and vibrant beachside restaurants."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India's tallest waterfalls, surrounded by lush forests and the Western Ghats. It is a major attraction for nature lovers and adventure enthusiasts."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site famous for housing the mortal remains of St. Francis Xavier and showcasing remarkable Portuguese architecture."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved 17th-century Portuguese fort offering panoramic views of the Arabian Sea and a historic lighthouse."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is famous for its rocky coastline, flea market, beach parties, and stunning sunsets, making it one of Goa's most popular tourist attractions."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort is a historic Portuguese fort known for its spectacular views of Vagator Beach and the Arabian Sea. It gained popularity through Bollywood movies."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is a beautiful South Goa destination known for its white sand, coconut trees, peaceful surroundings, and water sports activities."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach is a scenic crescent-shaped beach in South Goa known for its calm waters, natural beauty, kayaking, and relaxing atmosphere."
    },
    {
        title: "Mangueshi Temple",
        description:
            "Mangueshi Temple is one of Goa's most revered Hindu temples dedicated to Lord Shiva, admired for its elegant architecture and spiritual significance."
    }
],



services: [
  
    {
        name: "Sedan Pune to Goa Cab",
        description:
            "Book Sedan Pune to Goa Cab for affordable and comfortable long-distance travel, ideal for couples and small families seeking budget-friendly AC rides with smooth highway experience."
    },
    {
        name: "SUV Pune to Goa Taxi",
        description:
            "Rising Cab Service provides SUV Pune to Goa Taxi for group travel with extra space, comfort, and luggage capacity, making it perfect for family vacations and friends’ trips to Goa."
    },
    {
        name: "Innova Pune to Goa Cab",
        description:
            "Our Innova Pune to Goa Cab service ensures premium comfort, spacious seating, and smooth long-route travel, ideal for families and groups traveling to Goa for holidays or special occasions."
    },
    {
        name: "Family Trip Cab Pune Goa",
        description:
            "Book Family Trip Cab Pune Goa for safe, comfortable, and enjoyable vacation travel with customized stops, flexible timing, and experienced drivers for a stress-free journey."
    },
    {
        name: "Goa Tour Package by Cab from Pune",
        description:
            "Rising Cab Service offers Goa Tour Package by Cab from Pune including pickup, sightseeing, flexible travel plans, and return journey options covering North Goa, South Goa, beaches, and tourist attractions."
    },
    {
        name: "Pune to Goa Taxi Package",
        description:
            "Our Pune to Goa Taxi Package provides complete travel solutions including round-trip options, sightseeing support, and customized itineraries for a perfect Goa holiday experience."
    },
    {
        name: "Pune Goa Family Tour Cab Package",
        description:
            "Book Pune Goa Family Tour Cab Package for a safe and comfortable family vacation with well-planned routes, AC vehicles, and professional drivers ensuring smooth travel."
    },
    {
        name: "Luxury Goa Cab Package from Pune",
        description:
            "Rising Cab Service offers Luxury Goa Cab Package from Pune with premium vehicles, experienced chauffeurs, and high-end travel comfort for a luxurious holiday experience."
    },
    {
        name: "Pune to Goa Tempo Traveller Package",
        description:
            "Our Pune to Goa Tempo Traveller Package is ideal for large groups, offering spacious seating, entertainment options, and comfortable long-distance travel for group holidays."
    },
    {
        name: "Pune to Goa Vacation Cab Service",
        description:
            "Book Pune to Goa Vacation Cab Service for flexible holiday travel with customized stops, sightseeing options, and reliable long-route drivers for a relaxed journey."
    },
    {
        name: "Pune to Goa Innova Crysta",
        description:
            "Rising Cab Service provides Pune to Goa Innova Crysta for premium comfort, luxury seating, and smooth highway travel ideal for family and business trips."
    },
    {
        name: "Pune to North Goa Cab",
        description:
            "Our Pune to North Goa Cab service ensures direct and comfortable travel to popular beach destinations like Calangute, Baga, and Candolim with experienced drivers."
    },
    {
        name: "Pune to South Goa Taxi",
        description:
            "Book Pune to South Goa Taxi for peaceful and scenic travel to destinations like Colva, Palolem, and Agonda with safe and reliable long-distance service."
    },
    {
        name: "Pune to Calangute Cab",
        description:
            "Rising Cab Service offers Pune to Calangute Cab for convenient beach travel with comfortable AC vehicles and experienced drivers familiar with Goa routes."
    }
],
tableData: [
    ["Pune to Goa Cab", "Pune to Goa Taxi"],
    ["Cab from Pune to Goa", "Taxi from Pune to Goa"],
    ["Pune to Goa One Way Cab", "Pune to Goa Round Trip Taxi"],
    ["Pune to Goa Cab Service", "Pune to Goa Taxi Fare"],
    ["Sedan Pune to Goa Cab", "SUV Pune to Goa Taxi"],
    ["Innova Pune to Goa Cab", "Family Trip Cab Pune Goa"],
    ["Goa Tour Package by Cab from Pune", "Pune to Goa Taxi Package"],
    ["Luxury Goa Cab Package from Pune", "Pune to Goa Tempo Traveller Package"],
    ["Pune to North Goa Cab", "Pune to South Goa Taxi"],
    ["Pune to Goa Cab Booking", "24x7 Pune to Goa Cab Service"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Hyderabad Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Hyderabad cab transportation for business travelers, families, tourists, students, and long-distance travelers."
    },
    {
        WhyChooseheading: "Ideal for Interstate Travel",
        WhyChoosedescription: "Travel conveniently between Maharashtra and Telangana with professionally managed transportation designed for both personal and corporate travel requirements."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long Journeys",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to ensure a pleasant travel experience."
    },
    {
        WhyChooseheading: "Flexible Travel Packages Available",
        WhyChoosedescription: "Customers can choose one-way cab services, round trips, multi-day bookings, and customized itineraries based on their travel plans."
    },
    {
        WhyChooseheading: "Popular for Business and Family Visits",
        WhyChoosedescription: "Many passengers use our Pune to Hyderabad cab service for corporate meetings, family functions, educational visits, medical travel, and vacations."
    },
    {
        WhyChooseheading: "Pickup Service from Any Pune Location",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Safe Highway Travel with Experienced Drivers",
        WhyChoosedescription: "Our trained drivers are experienced on interstate routes and ensure smooth, secure, and comfortable travel throughout the journey."
    },
    {
        WhyChooseheading: "Customized Stops During the Journey",
        WhyChoosedescription: "Passengers can include meal breaks, overnight halts, sightseeing locations, and business stops according to their travel preferences."
    }
]
};

const faqData = [
    {
        question: "Why do travelers choose road travel from Pune to Hyderabad?",
        answer: "Road travel offers flexibility, personalized schedules, comfortable transportation, and convenient doorstep pickup and drop services."
    },
    {
        question: "Can I book a one-way cab from Pune to Hyderabad?",
        answer: "Yes, one-way transportation is available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is recommended for Pune to Hyderabad travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for long-distance comfort and luggage space."
    },
    {
        question: "Do you provide cabs for corporate travel to Hyderabad?",
        answer: "Yes, many professionals and companies use our service for business meetings, conferences, client visits, and official travel."
    },
    {
        question: "Can families travel comfortably on this route?",
        answer: "Yes, spacious vehicles with comfortable seating make the journey suitable for families, children, and senior citizens."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family tours, corporate teams, and group transportation."
    },
    {
        question: "Can multiple cities be covered during the trip?",
        answer: "Yes, customized itineraries can include additional destinations and travel stops based on customer requirements."
    },
    {
        question: "Is pickup available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential addresses."
    },
    {
        question: "Should customers book in advance for Pune to Hyderabad travel?",
        answer: "Advance booking is recommended to secure preferred vehicles and ensure smooth travel planning."
    },
    {
        question: "How can I reserve a Pune to Hyderabad Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rakesh Agrawal",
        feedback:
            "Our corporate team needed reliable transportation to Hyderabad, and Rising Cab Service delivered a seamless experience. The vehicle quality and driver professionalism were exceptional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Kulkarni",
        feedback:
            "Traveling to Hyderabad with family felt surprisingly comfortable despite the long distance. The journey was well planned, and every aspect of the trip was handled efficiently.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-goa-cab.jpg",
"description": "Book Pune to Goa Cab Service with Rising Cab Service for safe, comfortable, and scenic long-distance travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family and group trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-goa-cab-service"
}
};



    return (
        <div>

<Helmet>
  <title>Pune to Goa Cab Service | Scenic Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Goa Cab Service for safe and comfortable long-distance travel. Enjoy affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family trips."
/>

<meta
 name="keywords"
 content="pune to goa cab, pune to goa taxi, cab from pune to goa, taxi from pune to goa, pune to goa cab service, pune to goa taxi fare, pune to goa one way cab, pune to goa round trip taxi, pune to goa cab booking, cheap pune to goa cab, best pune to goa taxi, sedan pune to goa cab, suv pune to goa taxi, innova pune to goa cab, family trip cab pune goa"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoacabservice;